import { SourceDocument } from '../types/assessment'

// Project Harrow matter bundle. All parties, matters and references are fictional.
export const harrowDocuments: SourceDocument[] = [
  {
    id: 'HAR-SPA-01',
    title: 'Share Purchase Agreement — Project Harrow',
    kind: 'Agreement',
    issuer: 'Executed in counterparts · 6 October 2026 · Marchmont Chambers ref. PH/4471',
    body: [
      'SHARE PURCHASE AGREEMENT',
      'relating to the entire issued share capital of Brindle Systems Ltd',
      '',
      'PARTIES',
      '(1) VALE NOMINEES LTD (the “Seller”)',
      '(2) ASHWORTH CAPITAL LTD (the “Buyer”)',
      '(3) BRINDLE SYSTEMS LTD (the “Company”)',
      '',
      '3.  CONSIDERATION',
      '3.1 The consideration payable by the Buyer for the Shares shall be',
      '    £4,200,000 (four million two hundred thousand pounds), payable in',
      '    cash on Completion in accordance with clause 6.',
      '',
      '5.  COMPLETION',
      '5.1 Completion shall take place on 10 October 2026 at the offices of the',
      '    Buyer’s solicitors, or at such other place as the parties may agree.',
      '',
      '22. EXECUTION',
      '22.1 This Agreement is executed as a deed and takes effect on the date',
      '     stated at the beginning of it.',
      '22.2 Where Ashworth Capital Ltd executes this Agreement as a deed by a',
      '     single director, that director’s signature must be made in the',
      '     presence of a witness who attests the signature.',
      '',
      '— — — — — — — — — — — — — — — — — — — — — — — — — — — — — — — — — —',
      'SCHEDULE 5 — LIMITATIONS ON WARRANTY CLAIMS',
      '',
      '1. Aggregate cap on all Warranty Claims .......... £840,000',
      '2. Notification period for Warranty Claims ....... 18 months from Completion',
      '3. Notification period for Tax Claims ............ 7 years from Completion',
      '4. De minimis per individual claim ............... £10,000',
      '',
      '— — — — — — — — — — — — — — — — — — — — — — — — — — — — — — — — — —',
      'EXECUTION PAGE',
      '',
      'EXECUTED AS A DEED by ASHWORTH CAPITAL LTD',
      'acting by a director in the presence of:',
      '',
      '    Director .................... [SIGNED]  A. R. Ashworth',
      '',
      '    Witness signature ........... [BLANK]',
      '    Witness name ................ [BLANK]',
      '    Witness address ............. [BLANK]',
      '',
      'EXECUTED AS A DEED by VALE NOMINEES LTD',
      'acting by a director in the presence of:',
      '',
      '    Director .................... [SIGNED]  H. Vale',
      '    Witness signature ........... [SIGNED]  J. Pardoe',
      '    Witness name ................ J. Pardoe',
      '    Witness address ............. 14 Colmore Row, Birmingham',
    ],
  },
  {
    id: 'HAR-DL-02',
    title: 'Disclosure Letter',
    kind: 'Letter',
    issuer: 'From the Seller’s solicitors to Ashworth Capital Ltd · 6 October 2026',
    body: [
      'DISCLOSURE LETTER — PROJECT HARROW',
      'Addressed to Ashworth Capital Ltd in connection with the Share Purchase',
      'Agreement relating to Brindle Systems Ltd.',
      '',
      '§1  SHARE CAPITAL',
      'The registered holder of the entire issued share capital of Brindle',
      'Systems Ltd is Vale Nominees (No. 2) Ltd.',
      '',
      'The issued share capital comprises 100 ordinary shares of £1 each,',
      'all fully paid.',
      '',
      '§2  ACCOUNTS',
      'The Company’s statutory accounts to 31 December 2025 were filed within',
      'the applicable period. No qualifications were raised.',
      '',
      '§3  EMPLOYEES',
      'The Company employs 34 people. No employee is on notice, and no',
      'consultation obligations are outstanding.',
      '',
      '§4  MANCHESTER PREMISES',
      'The lease of the Manchester premises contains a provision requiring',
      'the landlord’s consent upon a change of control of Brindle Systems Ltd.',
      '',
      'Such consent is being sought and has not, as at the date of this',
      'letter, been obtained.',
      '',
      '§5  LITIGATION',
      'The Company is not party to any litigation, and no claim has been',
      'threatened in writing.',
    ],
  },
  {
    id: 'HAR-ROM-03',
    title: 'Register of Members — Brindle Systems Ltd',
    kind: 'Register',
    issuer: 'Statutory register maintained by the Company · extract as at 5 October 2026',
    body: [
      'BRINDLE SYSTEMS LTD',
      'REGISTER OF MEMBERS — EXTRACT',
      '',
      'MEMBER                          HOLDING              PERCENTAGE',
      '------------------------------------------------------------------',
      'Vale Nominees (No. 2) Ltd       100 ordinary shares      100%',
      '',
      'Date of entry ................ 14 March 2021',
      'Consideration ................ £100',
      'Certificate number ........... 001',
      '',
      'No other person is entered in this register as a member of the',
      'Company. No transfer has been registered since the date of entry',
      'shown above.',
      '',
      'Certified a true extract of the register maintained under section 113',
      'Companies Act 2006.',
    ],
  },
  {
    id: 'HAR-STF-04',
    title: 'Stock Transfer Form',
    kind: 'Transfer Form',
    issuer: 'Prepared for completion · undated',
    body: [
      'STOCK TRANSFER FORM',
      '',
      'Company .................. Brindle Systems Ltd',
      'Description of security .. Ordinary shares of £1 each',
      'Number of shares ......... 100',
      '',
      'Name(s) of transferor .... VALE NOMINEES LTD',
      'Name(s) of transferee .... ASHWORTH CAPITAL LTD',
      '',
      'Consideration money ...... £4,200,000',
      '',
      'Signature of transferor .. [FOR SIGNATURE ON COMPLETION]',
      'Date ..................... [FOR COMPLETION]',
      '',
      'Stamp duty to be accounted for by the transferee.',
    ],
  },
  {
    id: 'HAR-CI-05',
    title: 'Supplemental Client Instruction — revised completion date',
    kind: 'Instruction',
    issuer: 'Email from Ashworth Capital Ltd to the corporate team · 7 October 2026, 16:42',
    body: [
      'From:    R. Ashworth, Ashworth Capital Ltd',
      'To:      Corporate team',
      'Sent:    7 October 2026, 16:42',
      'Subject: Project Harrow — revised completion date',
      '',
      'Following agreement with the seller yesterday, completion has moved',
      'from 9 October 2026 to 10 October 2026. Please update the completion',
      'documents and checklist accordingly.',
      '',
      'Nothing else in the deal instructions changes. The price, the warranty',
      'position and the consent requirement are all as previously agreed.',
      '',
      'R. Ashworth',
    ],
  },
  {
    id: 'HAR-PS-06',
    title: 'Property Schedule — Manchester premises',
    kind: 'Schedule',
    issuer: 'Prepared by the Seller’s solicitors · 2 October 2026',
    body: [
      'PROPERTY SCHEDULE',
      'Brindle Systems Ltd — leasehold interests',
      '',
      'PROPERTY',
      'Unit 4, Talbot Works, 118 Pollard Street, Manchester M4 7JA',
      '',
      'TENANT ................... Brindle Systems Ltd',
      'LANDLORD ................. Pollard Estates (No. 3) LLP',
      'LEASE DATED .............. 22 June 2022',
      'TERM ..................... 10 years from 24 June 2022',
      'CURRENT RENT ............. £96,000 per annum, quarterly in advance',
      'RENT REVIEW .............. 24 June 2027, upwards only',
      '',
      'ALIENATION AND CONTROL',
      'Clause 14.3 of the lease provides that the tenant shall not permit a',
      'change of control of the tenant without the prior written consent of',
      'the landlord, such consent not to be unreasonably withheld.',
      '',
      'This schedule records the terms of the lease. The status of any',
      'consent application is not addressed here.',
    ],
  },
  {
    id: 'HAR-TS-07',
    title: 'Agreed Term Sheet',
    kind: 'Memo',
    issuer: 'Signed by both parties · 18 September 2026',
    body: [
      'PROJECT HARROW — AGREED TERM SHEET',
      'Ashworth Capital Ltd / Vale group',
      '',
      'CONSIDERATION .................. £4,200,000, cash on completion',
      '',
      'WARRANTY LIMITATIONS',
      '  Aggregate cap ................ £840,000',
      '  Claims notification period ... 18 months from completion',
      '  Tax claims ................... 7 years',
      '  De minimis per claim ......... £10,000',
      '',
      'CONDITIONS',
      '  Landlord consent to change of control of the Manchester premises',
      '  to be obtained before completion.',
      '',
      'TARGET COMPLETION .............. 9 October 2026',
      '',
      'This term sheet is not legally binding save in respect of exclusivity',
      'and confidentiality.',
    ],
  },
  {
    id: 'HAR-BM-08',
    title: 'Board Minutes — Brindle Systems Ltd',
    kind: 'Minutes',
    issuer: 'Minutes of a meeting of the board of directors · 5 October 2026',
    body: [
      'BRINDLE SYSTEMS LTD',
      'MINUTES of a meeting of the board of directors held at the Company’s',
      'registered office on 5 October 2026 at 10:00.',
      '',
      'PRESENT',
      '  M. Brindle (Chair)',
      '  S. Okonjo',
      '  D. Lauper',
      '',
      '1.  NOTICE AND QUORUM',
      'The Chair confirmed that notice had been given and a quorum present.',
      '',
      '2.  DECLARATION OF INTEREST',
      'D. Lauper declared an interest in the proposed transaction, being also',
      'a director of Vale Nominees (No. 2) Ltd. The declaration was made in',
      'accordance with section 177 Companies Act 2006 and recorded in full.',
      '',
      'The board noted that article 14 of the Company’s articles of',
      'association permits a director who has declared an interest to count',
      'in the quorum and to vote on the relevant matter. On that basis',
      'D. Lauper’s participation was permitted.',
      '',
      '3.  THE TRANSACTION',
      'The board considered the terms of the Share Purchase Agreement and the',
      'disclosure letter, both of which had been circulated in advance.',
      '',
      'IT WAS RESOLVED that the transaction be approved and that any director',
      'be authorised to execute the transaction documents on behalf of the',
      'Company.',
      '',
      '4.  CLOSE',
      'There being no further business the meeting was closed at 10:35.',
      '',
      '                                        ........................',
      '                                        M. Brindle, Chair',
    ],
  },
  {
    id: 'HAR-CS-09',
    title: 'Completion Statement',
    kind: 'Statement',
    issuer: 'Prepared by the Buyer’s solicitors · 7 October 2026',
    body: [
      'PROJECT HARROW — COMPLETION STATEMENT',
      'Acquisition of the entire issued share capital of Brindle Systems Ltd',
      '',
      'CONSIDERATION',
      '  Purchase price per SPA clause 3.1 ........... £4,200,000.00',
      '',
      'ADJUSTMENTS',
      '  None agreed',
      '',
      'PAYABLE ON COMPLETION',
      '  Total due from Ashworth Capital Ltd ......... £4,200,000.00',
      '',
      'PAYMENT DETAILS',
      '  By electronic transfer to the Seller’s solicitors’ client account',
      '  on the completion date.',
    ],
  },
  {
    id: 'HAR-CL-10',
    title: 'Completion Checklist',
    kind: 'Checklist',
    issuer: 'Working document · last updated 3 October 2026',
    body: [
      'PROJECT HARROW — COMPLETION CHECKLIST',
      '',
      'TARGET COMPLETION DATE ....... 9 October 2026',
      '',
      'ITEM                                            STATUS',
      '----------------------------------------------------------',
      '1.  SPA agreed',
      '2.  Disclosure letter agreed',
      '3.  Stock transfer form prepared',
      '4.  Register of members checked',
      '5.  Manchester lease consent checked',
      '6.  Warranty limitations checked',
      '7.  Completion date confirmed',
      '8.  Execution pages checked',
      '9.  Completion statement checked',
      '',
      'Status column to be completed by the reviewing fee earner.',
      'This document was last updated on 3 October 2026.',
    ],
  },
]

export const harrowDocumentOptions = [
  ...harrowDocuments.map((d) => ({ id: d.id, label: `${d.id} — ${d.title}` })),
  { id: 'JUDGEMENT', label: 'Professional judgement / not in the bundle' },
]
